import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import AlertsModule from './components/AlertsModule';
import MapModule from './components/MapModule';
import NetworkAnalysis from './components/NetworkAnalysis';
import NRWExplorer from './components/NRWExplorer';
import WaterQuality from './components/WaterQuality';
import ReportsModule from './components/ReportsModule';
import CommunicationModule from './components/CommunicationModule';
import AccountabilityModule from './components/AccountabilityModule';
import FieldVerification from './components/FieldVerification';
import CustomizationModule from './components/CustomizationModule';
import KeyPersonnel from './components/KeyPersonnel';
import ILKHunter from './components/ILKHunter';
import ValveControl from './components/ValveControl';
import BillingRevenue from './components/BillingRevenue';
import MaintenancePlanner from './components/MaintenancePlanner';
import PredictiveAnalytics from './components/PredictiveAnalytics';
import './App.css';

const AppContent = () => {
  const { user, loading } = useAuth();
  const [activeModule, setActiveModule] = useState('dashboard');

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  const renderModule = () => {
    switch (activeModule) {
      case 'dashboard':
        return <Dashboard setActiveModule={setActiveModule} />;
      case 'map':
        return <MapModule />;
      case 'alerts':
        return <AlertsModule />;
      case 'network':
        return <NetworkAnalysis />;
      case 'nrw':
        return <NRWExplorer />;
      case 'ilkhunter':
        return <ILKHunter />;
      case 'valve-control':
        return <ValveControl />;
      case 'billing':
        return <BillingRevenue />;
      case 'maintenance':
        return <MaintenancePlanner />;
      case 'predictive':
        return <PredictiveAnalytics />;
      case 'quality':
        return <WaterQuality />;
      case 'reports':
        return <ReportsModule />;
      case 'communication':
        return <CommunicationModule />;
      case 'accountability':
        return <AccountabilityModule />;
      case 'field':
        return <FieldVerification />;
      case 'personnel':
        return <KeyPersonnel />;
      case 'settings':
        return <CustomizationModule />;
      default:
        return <Dashboard setActiveModule={setActiveModule} />;
    }
  };

  return (
    <Layout activeModule={activeModule} setActiveModule={setActiveModule}>
      {renderModule()}
    </Layout>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<AppContent />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
